var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.37129 4.01425H20.4083C20.7914 4.01425 21.1284 4.1598 21.3966 4.42027C21.6341 4.65776 21.8026 4.99483 21.8026 5.38553V8.2047V8.30429H21.7107H15.8348C15.3522 8.30429 14.9002 8.49581 14.5861 8.83288C14.2491 9.14697 14.0575 9.60662 14.0575 10.0816V13.7664C14.0575 14.272 14.2491 14.7087 14.5861 15.0151C14.9002 15.3522 15.3599 15.5437 15.8348 15.5437H21.7107H21.8026V15.6433V18.4625C21.8026 18.8455 21.6341 19.1826 21.3966 19.4507C21.1361 19.6882 20.7914 19.8338 20.4083 19.8338H1.37129C1.01123 19.8338 0.651177 19.6882 0.406032 19.4507C0.168548 19.1826 0 18.8455 0 18.4625V5.38553C0 5.00249 0.168548 4.66542 0.406032 4.42027C0.651177 4.1598 1.01123 4.01425 1.37129 4.01425ZM15.8425 9.28487H22.0247C22.4537 9.28487 22.7908 9.64493 22.7908 10.0816V13.7664C22.7908 14.2031 22.4537 14.5631 22.0247 14.5631H15.8425C15.4058 14.5631 15.0688 14.2031 15.0688 13.7664V10.0816C15.0688 9.64493 15.4058 9.28487 15.8425 9.28487ZM1.3483 3.20221C5.6077 2.14502 13.1153 1.05719 17.3517 0C17.7347 0 17.9799 0.168539 18.1178 0.459649C18.3629 1.37128 18.6004 2.29057 18.8379 3.20221C14.1035 3.20221 6.09033 3.20221 1.3483 3.20221ZM18.8225 10.3497C19.6882 10.3497 20.3853 11.0239 20.3853 11.8895C20.3853 12.7322 19.6882 13.4293 18.8225 13.4293C17.9799 13.4293 17.2827 12.7322 17.2827 11.8895C17.2827 11.0239 17.9799 10.3497 18.8225 10.3497Z",
    fill: "url(#paint0_linear_302_8029)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_302_8029",
    x1: -4.73809,
    y1: 15.0093,
    x2: 23.6638,
    y2: 28.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973591,
    stopColor: "#1C3462"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.e960ee5463458eef4318bf707778620d.svg";
export { ForwardRef as ReactComponent };